export const ToDoList_DrakThemes = {
  bgColor: "#343a40",
  color: "#fff",
  bordeButton: "1px solid #fff",
  borderRadiusButton: "none",
  hoverTextColor: "#343a40",
  hoverBgColor: "#fff",
  borderColor: "#343a40",
};
